<script>
import { ref, onMounted } from 'vue'
import { Splide } from '@splidejs/splide'
import { Intersection } from '@splidejs/splide-extension-intersection'
import { attachPagination } from '@/services/splide-pagination'

const DEFAULTS = {
  updateOnMove: true,
  breakpoints: {
    500: {
      perPage: 1
    },
    1024: {
      perPage: 3
    }
  }
}

export default {
  name: 'renderless-splide',
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    grid: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { slots }) {
    const splide = ref(null)
    const attachExternalContent = ({ instance, selector }) => {
      const external = document.querySelector(selector)
      if (external) {
        const slides = external.querySelectorAll('[data-index]')
        const toggle = (index) => {
          slides.forEach(i => i.style.display = 'none')
          slides[index].style.display = 'block'
        }
        instance.on('moved', toggle)
        toggle(0)
      }
    }
    onMounted(() => {
      const options = { ...DEFAULTS, ...props.options }
      const $el = splide.value

      // remove elements hidden with CSS for limit products ab test
      if ($el.classList.contains('collection-slider')) {
        $el.querySelectorAll('.splide__slide').forEach(i => {
          if (i.offsetWidth + i.offsetHeight === 0) {
            i.parentNode.removeChild(i)
          }
        })
      }

      const instance = new Splide($el, options)
      attachPagination(instance, options)
      instance.mount({ Intersection })
      if (options.externalSelector) {
        attachExternalContent({ instance, selector: options.externalSelector })
      }
      if ($el.getAttribute('class').includes('scaled')) {
        instance.on('drag', function () {
          $el.classList.add('dragging')
        }).on('dragged', function () {
          $el.classList.remove('dragging')
        })
      }
    })
    return () => slots.default({
      splide
    })
  }
}
</script>
